export default {
    name: 'KPI',
    data() {
        return {
            WorkParameters: [],
            Start: moment().format('YYYY-MM-DD'),
            StartHour: '00',
            EndHour: '23',
            Column: '',
            Keyword: '',
        };
    },
    mounted() {
        window.model = this;
        this.load();
    },
    methods: {
        async load() {
            var result = await this.$api.getKPI();


            this.createDataTable('#tableWeek', result.Week.Column, result.Week.Data, {
                bSort: false, searching: false, paging: false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "機台關鍵績效指標"
                },{
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "機台關鍵績效指標"
                }]
            });

            this.createDataTable('#tableMonth', result.Month.Column, result.Month.Data, {
                bSort: false, searching: false, paging: false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "機台關鍵績效指標"
                },{
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "機台關鍵績效指標"
                }]
            });

            this.createDataTable('#tableYear', result.Year.Column, result.Year.Data, {
                bSort: false, searching: false, paging: false,
                buttons: [{
                    extend: "excelHtml5",
                    className: "hide",
                    autoFilter: true,
                    text: "excel",
                    title: "機台關鍵績效指標"
                },{
                    extend: "csv",
                    className: "hide",
                    autoFilter: true,
                    text: "csv",
                    title: "機台關鍵績效指標"
                }]
            });
        },
        async search() {
            var result = await this.$api.searchDataHistory(`${this.Start} ${this.StartHour}:00:00`, `${this.Start} ${this.EndHour}:59:59`, this.Column, this.Keyword);
            var cols = [
                {
                    title: "時間",
                    data: "Time",
                    width: 100,
                    render: window.filters.dateTimeFormat
                }
            ];

            result.Header.forEach(c => cols.push({
                title: c,
                data: c
            }));
            this.createDataTable('#tableData', cols, result.Data, { bSort: false, searching: false });
        },
        exportCSV(){
            $('.tab-pane.active button.buttons-csv').trigger('click');
        },
        exportExcel(){
            $('.tab-pane.active button.buttons-excel').trigger('click');
        }
    }
}